import { useT } from '../../i18n'
interface Props {
  playerName: string
  players: string[]
}

/**
 * Lobby view on the phone: "You're in" + player list + nudge to watch the TV.
 * No start button — in TV mode the TV is the host, never the phone.
 */
export function JoinLobbyPhase({ playerName, players }: Props) {
  const t = useT()
  return (
    <div className="flex-1 flex flex-col px-5 py-6">
      <div className="text-center mb-8">
        <p className="text-xs font-semibold uppercase tracking-widest text-iet-green mb-1">{t("You're in")}</p>
        <h1 className="font-display text-4xl font-bold text-brand-text">
          Hi, {playerName}
        </h1>
        <p className="text-brand-muted mt-1">{t("Look up. You'll see the game on the TV.")}</p>
      </div>

      <div className="mb-8">
        <p className="text-xs font-semibold uppercase tracking-wide text-brand-muted mb-2">
          {players.length === 1 ? t('1 Player') : t('{n} Players', { n: players.length })}
        </p>
        <div className="space-y-2">
          {players.map(n => (
            <div key={n} className="card p-3 text-brand-text font-medium">{n}</div>
          ))}
        </div>
      </div>

      <p className="text-center text-sm text-brand-muted mt-auto">{t("The TV will start the game when everyone's in.")}</p>
    </div>
  )
}
